import { Model } from '@vuex-orm/core'
import Building from '@models/building/Building'
import Unit from '@models/building/Unit'
import Room from '@models/building/Room'
import Roomairvolume from '@models/airvolumes/Roomairvolume'

export default class Unitairvolume extends Model{
  static entity = 'unitairvolumes'

  static fields () {
    return {
      id: this.uid(),
      unitId: this.attr(null),

      volume: this.number(0),
      space: this.number(0),
      height: this.number(0),

      totalFrZu: this.number(0),
      totalFrZuKorr: this.number(0),
      nl: this.number(0),
      rl: this.number(0),
      il: this.number(0),
      fl: this.number(0),

      nlExchange: this.number(0),
      rlExchange: this.number(0),
      ilExchange: this.number(0),
      flExchange: this.number(0),

      exhaustAir: this.number(0),
      infiltrationAir: this.number(0),
      ald: this.number(0),
      heatRecoveryArea: this.number(0),
      totalSupplyAir: this.number(0),
      totalExhaustAir: this.number(0),

      manually: this.number(0),
      totalNeedAir: this.number(0),
      totalDurationAir: this.number(0),
    }
  }

	basicCalculations() {
		this.space = 0
		this.height = 0
		this.volume = 0

		this.aldSpace = 0
		this.aldVolume = 0

		this.rooms.forEach( function(room) {
      if(room.ventilationMeasure != 6) this.space += room.space
      if(room.ventilationMeasure != 1) this.aldSpace += room.space
      this.height += room.height
      if(room.airType == 3) room.airvolume.resetOverflowRoom()
		}.bind(this))

		this.height = this.height / this.rooms.length
    this.volume = +parseFloat((this.space * this.height).toFixed(2))
    this.aldVolume = +parseFloat((this.aldSpace * this.height).toFixed(2))
	}
}
